module.exports = __webpack_public_path__ + "static/img/expand-the-possibilities__large.32ecaeb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyTour/img/primary/expand-the-possibilities__large.jpg
// module id = JT58
// module chunks = 1